/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/**
 * Player Options Interface.
 */
export interface IPlayerOptions {
    autoplay?: boolean;
    mute?: boolean;
    loop?: boolean;
    playPauseTrigger?: boolean;
    controls?: boolean;
    maskLevel?: number;
    market?: string;
    playbackSpeed?: boolean;
    download?: boolean;
    playFullScreen?: boolean;
    hidePosterFrame?: boolean;
    autoCaptions?: string;
    flexSize?: boolean;
    aspectRatio?: number;
    userMinimumAge?: number;
    showEndImage?: boolean;
    showImageForVideoError?: boolean;
    inviewPlay?: boolean;
    inviewThreshold?: number;
    inViewWidthFraction?: number;
    inViewHeightFraction?: number;
    controlPanelTimeout?: number;
    thumbnailFullWidth?: boolean;
    ageGate?: boolean;
    lazyLoad?: boolean;
    mobileVideoQuality?: MobileVideoQuality;
    shouldDisableAutoPlayOnMobile?: boolean;
    isMobileDevice?: boolean;
}

/**
 * Mobile video quality.
 */
export enum MobileVideoQuality {
    hdx = 'hdx',
    hq = 'hq',
    sd = 'sd',
    lo = 'lo'
}
